import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export async function fetchClasses(params = {}) {
    const { data } = await api.get("/classes", { params });
    return data;
}

export async function fetchNear(params = {}) {
    const { data } = await api.get("/near", { params });
    return data;
}

export async function fetchLiveStatus() {
    const { data } = await api.get("/live/status");
    return data;
}

export async function fetchStats() {
    const { data } = await api.get("/stats");
    return data;
}

export async function fetchFilters() {
    const { data } = await api.get("/filters");
    return data;
}

export async function fetchNowSnapshot() {
    const { data } = await api.get("/now");
    return data;
}

export async function fetchManualReview() {
    const { data } = await api.get("/manual-review");
    return data;
}

export function csvDownloadUrl() {
    return `${API}/export/csv`;
}

export async function sendChat({ message, sessionId, userLat, userLng }) {
    const { data } = await api.post("/chat", {
        message,
        session_id: sessionId,
        user_lat: userLat,
        user_lng: userLng,
    });
    return data;
}
